import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../context/AuthContext';
import { generatePastelGradient } from '../utils/colorUtils';
import '../styles/Auth.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [gradient, setGradient] = useState('');
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    setGradient(generatePastelGradient());
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Don't clear error before result — it will be replaced when the response arrives
    setLoading(true);

    const result = await login(username, password);

    if (result.success) {
      if (result.mfaRequired) {
        navigate('/mfa-verify', { state: { tempToken: result.tempToken } });
      } else if (result.mustChangePassword) {
        navigate('/change-password', { state: { changePwToken: result.changePwToken, reason: result.reason } });
      } else {
        const role = result.user?.role;
        const adminRoles = ['ADMIN', 'IT', 'SUPERADMIN', 'HR', 'FACILITY'];
        navigate(adminRoles.includes(role) ? '/admin' : '/dashboard');
      }
    } else {
      setError(result.error);
    }

    setLoading(false);
  };

  return (
    <div className="auth-container" style={{ background: gradient }}>
      <div className="auth-card">
        <h1>Staff IT</h1>
        <p className="auth-slogan">Bureaucracy made simple</p>
        <h2>Login</h2>
        
        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={loading}
            />
          </div>

          <button type="submit" disabled={loading} className="btn-primary">
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>

        <p className="auth-toggle">
          <a href="/forgot-password">Forgot my password?</a>
        </p>
      </div>
    </div>
  );
};

export default Login;
